import React from "react";
import "./messageform.css";
import { CameraAlt } from "@mui/icons-material";

const MessageForm = ({ handleSubmit, text, setText, setImg }) => {
  return (
    <div className="message-form">
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Enter message"
        />

        <button type="submit">Send</button>

        <label className="label" htmlFor="img">
          <CameraAlt />
        </label>
        <input
          onChange={(e) => setImg(e.target.files[0])}
          type="file"
          id="img"
          accept="image/*"
          style={{ display: "none" }}
        />
      </form>
    </div>
  );
};

export default MessageForm;
